import CONSTANTS from '../constants'
import { EMPTY_OBJECT } from '../../constants/globalConstants'

const INITIAL_STATE = {
	loader: false,
	hasError:false,
	events: EMPTY_OBJECT,
	passDetails: EMPTY_OBJECT,
	event_type: '',
	errorMessage: '',
}

const eventDetailsReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {

	//RESPONSE HANDLING
	case CONSTANTS.EVENT_INITIAL_REQUEST:
		return {
			...state,
			loader: true,
			errorMessage: ''
		}
	case CONSTANTS.EVENT_INITIAL_SUCCESS:
		return{
			...state,
			loader: false,
			events: action.data,
			hasError: false,
			errorMessage: ''
		}
	case CONSTANTS.EVENT_INITIAL_FAILURE:
		return {
			...state,
			loader: false,
			errorMessage: 'There is some Error'
		}
	case CONSTANTS.UPDATE_EVENT_STATE:
		return { ...state, ...action.update }
	case CONSTANTS.PASS_INITIAL_REQUEST:
		return {
			...state,
			loader: true,
			errorMessage: ''
		}
	case CONSTANTS.PASS_INITIAL_SUCCESS:
		return{
			...state,
			loader: false,
			passDetails: action.data,
			hasError: false,
			errorMessage: ''
		}
	case CONSTANTS.PASS_INITIAL_FAILURE:
		return {
			...state,
			loader: false,
			errorMessage: 'There is some Error'
		}	

	default:
		return state
	}
}

export default eventDetailsReducer
